const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'json'];
const MAX_SIZE = 2 * 1024 * 1024; // 2MB

export const validateFileHeader = async (file) => {

  if (file.size > MAX_SIZE) throw new Error("File too large (Max 2MB)");

  const ext = file.name.split('.').pop().toLowerCase();
  if (!ALLOWED_EXTENSIONS.includes(ext)) {
    throw new Error(`Extension .${ext} not allowed`);
  }

  if (ext === 'json') {
    try {
      const text = await file.text();
      JSON.parse(text); 
      return true;
    } catch (e) {
      throw new Error("Invalid JSON: The file content is not a valid JSON structure.");
    }
  }

  const buffer = await file.arrayBuffer();
  const uint = new Uint8Array(buffer).subarray(0, 4);
  let header = "";
  for (let i = 0; i < uint.length; i++) {
    header += uint[i].toString(16);
  }

  // PNG: 89504e47 | JPG: ffd8ff
  const isPNG = header.startsWith("89504e47");
  const isJPG = header.startsWith("ffd8ff");

  if (!isPNG && !isJPG) {
    throw new Error("Invalid content: The file signature does not match an allowed image.");
  }

  return true;
};